
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.307 4.676c.438.445.693 1.039.693 1.67v10.279C14 17.961 12.943 19 11.667 19H2.333C1.021 19 0 17.96 0 16.625V2.375C0 1.076 1.02 0 2.333 0h5.433a2.3 2.3 0 011.64.705l3.901 3.97zm-5.14-3.377v4.045c0 .334.255.593.583.593h3.974a.938.938 0 00-.255-.445L8.604 1.56a.913.913 0 00-.437-.26zm4.666 15.326v-9.5H8.75c-.984 0-1.75-.78-1.75-1.781V1.187H2.333c-.656 0-1.166.557-1.166 1.188v14.25c0 .668.51 1.188 1.166 1.188h9.334c.62 0 1.166-.52 1.166-1.188zm-5.468-5.863c.255.445.583.853.947 1.187.438-.074 1.313-.222 1.896-.222.802 0 1.459.668 1.459 1.447 0 .78-.62 1.41-1.422 1.41-.766 0-1.86-.668-2.297-.965-.802.186-1.495.371-2.115.631-.51.89-.948 1.559-1.166 1.855-.256.334-.657.52-1.058.52-.729 0-1.276-.557-1.276-1.299 0-.37.11-.705.365-.965.51-.52 1.203-.965 2.042-1.373.364-.705.692-1.447.947-2.152-.51-1.299-.51-2.375-.51-2.375 0-.742.583-1.336 1.276-1.336.73 0 1.313.594 1.313 1.336 0 .185-.037 1.113-.401 2.3zm-3.537 4.713c.146-.223.438-.631.802-1.262-.437.26-.875.557-1.203.928-.036.037-.073.074-.073.148 0 .297.328.371.474.186zM6.453 8.2a.251.251 0 00-.255.26c0 .037 0 .742.292 1.596.072-.297.218-1.04.218-1.596 0-.149-.109-.26-.255-.26zm-.62 4.899c.584-.186 1.167-.334 1.714-.483a4.67 4.67 0 01-.948-1.187c-.255.593-.51 1.187-.766 1.67zm4.375-.297c-.437 0-1.385.148-1.422.148.365.223 1.13.594 1.459.594.219 0 .364-.149.364-.334a.386.386 0 00-.4-.408z","fill":"#333"}})])
          )
        }
      }
    